import { CRUDApiService } from "./CRUDApiService";

export class QuizApiService extends CRUDApiService {
  constructor() {
    super('quiz');
  }
}
